import { StatusBadge } from '@/components/shared/StatusBadge';

/**
 * Historique complet des alertes du patient
 * Utilisé par NursePatientDetail et DoctorPatientDetail
 */
export default function AlertsHistory({ 
  alerts, 
  onResolveAlert,
  userRole = "nurse" // "nurse" | "doctor"
}) {
  return (
    <div className="dash-card">
      <h3 className="font-semibold text-slate-800 mb-4">Historique des alertes</h3>
      {alerts.length === 0 ? (
        <p className="text-slate-400 text-center py-8">Aucune alerte</p>
      ) : (
        <div className="space-y-3">
          {alerts.map(alert => (
            <div key={alert.id} className={`p-4 rounded-xl border ${
              alert.status === "RESOLVED" || alert.status === "VALIDATED"
                ? "bg-slate-50 border-slate-200" 
                : "bg-amber-50 border-amber-200"
            }`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <StatusBadge status={alert.level || alert.patientStatus} />
                    <span className={`text-xs px-2 py-0.5 rounded-full ${
                      alert.status === "RESOLVED" || alert.status === "VALIDATED"
                        ? "bg-green-100 text-green-700"
                        : alert.status === "ESCALATED"
                        ? "bg-blue-100 text-blue-700"
                        : "bg-amber-100 text-amber-700"
                    }`}>
                      {alert.status === "RESOLVED" ? "Résolue" : 
                       alert.status === "VALIDATED" ? "Validée" :
                       alert.status === "ESCALATED" ? "Escaladée" :
                       alert.status === "IN_PROGRESS" ? "En cours" :
                       "Nouvelle"}
                    </span>
                  </div>
                  {alert.reasons && alert.reasons.length > 0 && (
                    <ul className="text-sm text-slate-600 mb-2">
                      {alert.reasons.map((r, i) => (
                        <li key={i}>• {r}</li>
                      ))}
                    </ul>
                  )}
                  <p className="text-xs text-slate-400">
                    Créée le {new Date(alert.createdAt).toLocaleDateString("fr-FR", {
                      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit"
                    })}
                    {alert.resolvedAt && ` — Résolue le ${new Date(alert.resolvedAt).toLocaleDateString("fr-FR", {
                      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit"
                    })}`}
                    {alert.validatedAt && ` — Validée le ${new Date(alert.validatedAt).toLocaleDateString("fr-FR", {
                      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit"
                    })}`}
                  </p>
                  {/* Transmission complète */}
                  {alert.transmission && (
                    <div className="mt-2 p-2 bg-white/50 rounded-lg border border-slate-200">
                      <p className="text-xs font-medium text-slate-600 mb-1">Transmission :</p>
                      <p className="text-sm text-slate-700 whitespace-pre-wrap">{alert.transmission}</p>
                    </div>
                  )}
                  {alert.resolutionOutcome && (
                    <p className="text-xs text-emerald-600 mt-1">
                      Issue: {alert.resolutionOutcome === "hospitalisation_necessaire" ? "Hospitalisation nécessaire" : alert.resolutionOutcome === "erreur_declaration" ? "Erreur de déclaration" :
                             alert.resolutionOutcome === "hospitalisation_evitee" ? "Hospitalisation évitée" : "Simple surveillance"}
                    </p>
                  )}
                  {alert.medicalDecision && (
                    <p className="text-xs text-emerald-600 mt-1">
                      Décision médicale: {alert.medicalDecision}
                    </p>
                  )}
                </div>
                {alert.status !== "RESOLVED" && alert.status !== "VALIDATED" && onResolveAlert && (
                  <button
                    onClick={() => onResolveAlert(alert.id)}
                    className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700"
                  >
                    Résoudre
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
